<div style="position: relative">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
			sectionclass
		}} u-color-white-900 u-bg-accent-2"
	>
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header"
		>
			<div class="o-stack__cell">
				<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
				<span *ngIf="downloadConfiguration.enableDownload && hasData" class="datatable-icon">
					<a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV($event)" target="_blank">
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content u-pt-small lift_quick_stats_portlet_content">
			<div class="o-stack o-stack--center _u-px-small {{ sectionclass.substr(-17) }}" *ngIf="quickStatsData && hasData">
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of Exposures"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.exposures !== null"
				>
					<h5 class="u-color-white-900">Exposures</h5>
					<div class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.exposures; else exposuresBlock">
						{{ quickStatsData.exposures | formatNumber }}
					</div>
					<ng-template #exposuresBlock>
						<div class="u-font-medium u-lh-normal u-opacity-80p">--</div>
					</ng-template>
				</div>
				<span
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of ads shown to users"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.impressions !== null"
				>
					<h5 class="u-color-white-900">Impressions</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.impressions; else impressionsblock"
						>{{ quickStatsData.impressions | formatNumber }}</span
					>
					<ng-template #impressionsblock>
						<span class="u-font-small u-lh-normal u-opacity-80p"> -- </span>
					</ng-template>
				</span>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Visits + Ad Interactions"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.engagements !== null"
				>
					<h5 class="u-color-white-900">Engagements</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.engagementPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Engagements Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.engagementPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.engagements; else engagementblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.engagements | formatNumber }}
					</div>
					<ng-template #engagementblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Tooltip"
					[title]="adInteractionTooltip"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.adInteractions !== null"
				>
					<h5 class="u-color-white-900">Ad Interactions</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.adInteractionsPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Ad Interactions Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.adInteractionsPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.adInteractions; else adinteractionsblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.adInteractions | formatNumber }}
					</div>
					<ng-template #adinteractionsblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Clicks + View Throughs"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.visitsPercentage !== null"
				>
					<h5 class="u-color-white-900">Visits</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.visitsPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Visits Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.visitsPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.totalVisits; else visitsblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.totalVisits | formatNumber }}
					</div>
					<ng-template #visitsblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Visits to conversion page by impressioned users (who did not click - Pre Roll & Display Only)"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.viewThroughs !== null"
				>
					<h5 class="u-color-white-900">View Throughs</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.viewThroughsPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="View Throughs Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.viewThroughsPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.viewThroughs; else viewthroughblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.viewThroughs | formatNumber }}
					</div>
					<ng-template #viewthroughblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<span
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of emails sent"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.audience !== null"
				>
					<h5 class="u-color-white-900">Sends</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.audience; else audienceblock">{{
						quickStatsData.audience | formatNumber
					}}</span>
					<ng-template #audienceblock>
						<span class="u-font-small u-lh-normal u-opacity-80p"> -- </span>
					</ng-template>
				</span>
				<div class="o-stack__cell content_mainCls" *ngIf="quickStatsData.opens !== null && !isR7Series && isEmail">
					<h5 class="u-color-white-900">Opens</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.opensPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Opens Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.opensPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.opens; else opensblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.opens | formatNumber }}
					</div>
					<ng-template #opensblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
					<div class="quick-stats-tooltip">
						<div>
							Number of emails opened<br /><br />Open Rate = Opens/Sends <br /><br />Please note: Opens are attributed
							to the campaign’s deployment date for reporting purposes.
						</div>
						<div class="tooltip-triangle"></div>
					</div>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of emails opened<br /><br />Open Rate = Opens/Sends <br/><br/>Please note: Opens are attributed to the campaign’s deployment date for reporting purposes."
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.opens !== null && isR7Series && isEmail"
				>
					<h5 class="u-color-white-900">Opens</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p">{{ quickStatsData.opensPercentage }}%</span>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.opens; else opensblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.opens | formatNumber }}
					</div>
					<ng-template #opensblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="clicksToolTip"
					[title]="clicksToolTip"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.clicks !== null && !isEmail && !isGAM"
				>
					<h5 class="u-color-white-900">Clicks</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Clicks Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.clicks; else clicksblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.clicks | formatNumber }}
					</div>
					<ng-template #clicksblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="clicksToolTip"
					[title]="clicksToolTip"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.clicks !== null && isGAM"
				>
					<h5 class="u-color-white-900">Clicks</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.clicks; else clicksblock">{{
						quickStatsData.clicks | formatNumber
					}}</span>
					<ng-template #clicksblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="clicksToolTip"
					[title]="clicksToolTip"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.clicksPercentage !== null && isGAM"
				>
					<h5 class="u-color-white-900">Click Rate</h5>
					<span
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.clicksPercentage; else clickRateblock"
						>{{ quickStatsData.clicksPercentage | formatNumber }}%</span
					>
					<ng-template #clickRateblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div class="o-stack__cell content_mainCls" *ngIf="quickStatsData.clicks !== null && !isR7Series && isEmail">
					<h5 class="u-color-white-900">Clicks</h5>
					<span *ngIf="!isR8" class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<span
						*ngIf="isR8"
						appTooltip
						title="Clicks Rate"
						data-size="big"
						[options]="tooltipOptions"
						class="u-font-medium u-lh-normal u-opacity-80p"
						>{{ quickStatsData.clicksPercentage }}%</span
					>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.clicks; else clicksblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.clicks | formatNumber }}
					</div>
					<ng-template #clicksblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
					<div class="quick-stats-tooltip">
						<div>
							Number of clicks within an email<br /><br />Click Rate = Clicks/Sends <br /><br />Please note: Clicks are
							attributed to the campaign’s deployment date for reporting purposes.
						</div>
						<div class="tooltip-triangle"></div>
					</div>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of clicks within an email<br /><br />Click Rate = Clicks/Sends <br /><br />Please note: Clicks are attributed to the campaign’s deployment date for reporting purposes."
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.clicks !== null && isR7Series && isEmail"
				>
					<h5 class="u-color-white-900">Clicks</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p">{{ quickStatsData.clicksPercentage }}%</span>
					<div
						class="u-color-white-900 span_intraction"
						*ngIf="quickStatsData.clicks; else clicksblock"
						style="font-size: 1.2em"
					>
						{{ quickStatsData.clicks | formatNumber }}
					</div>
					<ng-template #clicksblock>
						<div class="u-color-white-900 span_intraction" style="font-size: 1.2em">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="People that have visited your targeted location"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.offlineVisits !== null"
				>
					<h5 class="u-color-white-900">Offline Visits</h5>
					<div class="u-font-medium u-lh-normal u-opacity-80p">
						{{ quickStatsData.offlineVisits | formatNumber }}
					</div>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of Exposures"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.airedSpots !== null"
				>
					<h5 class="u-color-white-900">Exposures</h5>
					<div class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.airedSpots; else airedSpotsblock">
						{{ quickStatsData.airedSpots | formatNumber }}
					</div>
					<ng-template #airedSpotsblock>
						<div class="u-font-medium u-lh-normal u-opacity-80p">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of Zones"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.zones !== null"
				>
					<h5 class="u-color-white-900">Zones</h5>
					<div class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.zones; else zonesblock">
						{{ quickStatsData.zones | formatNumber }}
					</div>
					<ng-template #zonesblock>
						<div class="u-font-medium u-lh-normal u-opacity-80p">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Name of top TV network by exposures"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.topNetwork !== null"
				>
					<h5 class="u-color-white-900">Top TV Network</h5>
					<div class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.topNetwork; else topNetworkblock">
						{{ quickStatsData.topNetwork | formatNumber }}
					</div>
					<ng-template #topNetworkblock>
						<div class="u-font-medium u-lh-normal u-opacity-80p">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls topNetwork"
					appTooltip
					title="Total exposures for Top TV Network"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.topNetworkAiredSpots !== null"
				>
					<h5 class="u-color-white-900">Top TV Network Exposures</h5>
					<div
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.topNetworkAiredSpots; else topNetworkAiredSpotsblock"
					>
						{{ quickStatsData.topNetworkAiredSpots | formatNumber }}
					</div>
					<ng-template #topNetworkAiredSpotsblock>
						<div class="u-font-medium u-lh-normal u-opacity-80p">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Name of top TV program by exposures"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.topProgram !== null"
				>
					<h5 class="u-color-white-900">Top Program</h5>
					<div class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.topProgram; else topProgramblock">
						{{ quickStatsData.topProgram }}
					</div>
					<ng-template #topProgramblock>
						<div class="u-font-medium u-lh-normal u-opacity-80p">--</div>
					</ng-template>
				</div>
				<div
					class="o-stack__cell content_mainCls totalTopProgram"
					appTooltip
					title="Number of exposures for the top TV program "
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="quickStatsData.topProgramAiredSpots !== null"
				>
					<h5 class="u-color-white-900">Top Program Exposures</h5>
					<div
						class="u-font-medium u-lh-normal u-opacity-80p"
						*ngIf="quickStatsData.topProgramAiredSpots; else topProgramAiredSpotsblock"
					>
						{{ quickStatsData.topProgramAiredSpots | formatNumber }}
					</div>
					<ng-template #topProgramAiredSpotsblock>
						<div class="u-color-white-900 span_intraction">--</div>
					</ng-template>
				</div>
				<span
					class="o-stack__cell content_mainCls"
					appTooltip
					title="Number of Ad Plays"
					data-size="big"
					[options]="tooltipOptions"
					*ngIf="isR1 && isDOOHenabled && quickStatsData.adplays !== null"
				>
					<h5 class="u-color-white-900">Ad Plays</h5>
					<span class="u-font-medium u-lh-normal u-opacity-80p" *ngIf="quickStatsData.adplays; else adplaysblock">{{
						quickStatsData.adplays | formatNumber
					}}</span>
					<ng-template #adplaysblock>
						<span class="u-font-small u-lh-normal u-opacity-80p"> -- </span>
					</ng-template>
				</span>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<div
					class="c-portlet o-block u-width-100p _u-width-100p stats-container u-shadow-mini {{
						sectionclass
					}} u-color-white-900 u-bg-accent-2"
				>
					<div
						class="c-portlet__header o-stack o-stack--center o-stack--splitted u-px-small u-py-mini lift_quick_stacks_header"
					>
						<div class="o-stack__cell">
							<h5 class="u-color-white-900">{{ sectiontitle }}</h5>
						</div>
					</div>
					<div class="map-no-data" style="text-align: center; color: #fff">No Data to Display</div>
				</div>
			</div>
		</div>
	</div>
</div>
